import { render, staticRenderFns } from "./GridFigure.vue?vue&type=template&id=3ce43853&scoped=true&"
import script from "./GridFigure.vue?vue&type=script&lang=js&"
export * from "./GridFigure.vue?vue&type=script&lang=js&"
import style0 from "./GridFigure.vue?vue&type=style&index=0&id=3ce43853&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce43853",
  null
  
)

export default component.exports